import BaseType from "../BaseType";
import Guid from "../Guid";
import Kit from "../Kit/Kit";

export default class ProgramSupportKit extends BaseType {
  ProgramSupportId: string = Guid.Empty;
  KitId: string = "";
  Kit: Kit = new Kit();
}
